module.exports = __webpack_public_path__ + "static/media/china.4e4d59b7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/flag/china.svg
// module id = 426
// module chunks = 120